import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getUsers, addUserApi } from '../../api/user.api';
import { User } from '../../model/user.model';
import GenericBoard from '../Generic/GenericBoard';
import GenericTab from '../Generic/GenericTab';
import './user.css';
import { Modal, Box } from '@mui/material';
import Swal from 'sweetalert2';
import { Provider, useSelector } from 'react-redux';
import AddUserForm from './addUser.component';
import store from '../../Redux/Store';
import ReactDOM from 'react-dom';
import ChatTable from "../tasks/chat";
import UserInfoView from './userInfo';
const UserTable: React.FC = () => {
  const dispatch = useDispatch();
  const [view, setView] = useState<'board' | 'list'>('board');
  const [users, setUsers] = useState<User[]>([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [showSearch, setShowSearch] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState<User | null>(null);
  const fetchData = async () => {
    const usersRes = await getUsers();

    const enrichedUsers = usersRes.map((user: User) => ({
      ...user,
      fullName: `${user.firstName ?? ''} ${user.lastName ?? ''}`.trim(), // הוספת השדה fullName
    }));

    setUsers(enrichedUsers);
  };
  useEffect(() => {
    fetchData();
  }, [dispatch]);
useEffect(() =>{
console.log(selectedUser)
},[selectedUser])
  const addUser = () => {
    Swal.fire({
      title: 'הוספת משתמש חדש',
      html: '<div id="add-lead-container"></div>',
      showCloseButton: true,
      showCancelButton: false,
      showConfirmButton: false,
      didOpen: () => {
        const container = document.getElementById('add-lead-container');
        if (container) {
          ReactDOM.render(
            <Provider store={store}>
              <AddUserForm
                users={users}
                setUser={setUsers}
                handleUserAdded={async (newUser: User) => {
                  try {
                    const existingUser = users.find(user => user.email.toLowerCase() === newUser.email.toLowerCase());
                    if (existingUser) {
                      Swal.fire('', 'כבר קיים משתמש עם האימייל הזה במערכת', 'warning');

                    }else{
                        const response = await addUserApi(newUser);
                    const addedUser = response.data;
                    setUsers(prevUsers => [...prevUsers, newUser]);
                    Swal.fire('', 'המשתמש נוסף בהצלחה', 'success');

                    }
                  
                  } catch (error) {
                       console.error("⚠️ Error from server:", error.response?.data);
                    Swal.fire('', 'שגיאה בהוספת המשתמש', 'error');
                  }
                }}
              />
            </Provider>,
            container
          );
        }
      },
    });
  };

  const config = {
    categoryField: "userType.description",
    categories: [
      { label: "מנהל", color: "#2c6d8f" },
      { label: "עובד", color: "#2c6d8f" },
      { label: "עובד לידים", color: "#2c6d8f" },
      { label: "לקוח", color: "#2c6d8f" }
    ],
    displayFields: [
      { key: "fullName", label: "שם" },
      { key: "email", label: "אימייל" }
    ],
    actionLabel: "עדכן",
    idField:"id"
  };

  const configTab = {
    ...config,
    displayFields: [
      ...config.displayFields,
      { key: "userType.description", label: "תפקיד" }
    ]
  };

  const filteredUsers = users.filter((user) => {
    const combinedValues = [
      user.firstName,
      user.lastName,
      user.email,
    ]
      .join(' ')
      .toLowerCase();
    return combinedValues.includes(searchTerm.toLowerCase());
  });

const openUserPopup = (id: string) => {
   const user = users.find(l => l.id === id);
  if (user) {
    setSelectedUser(user);
    setModalOpen(true);
  }
}
  return (
    <div className="user-board-container">
      <div className="tabs-container">
        <div className={`tab ${view === 'board' ? 'active' : ''}`} onClick={() => setView('board')}>
          לוח
        </div>
        <div className={`tab ${view === 'list' ? 'active' : ''}`} onClick={() => setView('list')}>
          רשימה
        </div>
      </div>

      <div className="header-wrapper">
        <div className="header-content">
          <div className="left-section">
            <button
              className="search-toggle"
              onClick={() => setShowSearch(!showSearch)}
              title="חיפוש"
            >
              <svg xmlns="http://www.w3.org/2000/svg" height="50" viewBox="0 0 24 24" width="50" fill="#2c3e50">
                <path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C8.01 14 6 11.99 6 9.5S8.01 5 10.5 5 15 7.01 15 9.5 12.99 14 10.5 14z" />
              </svg>
            </button>

            {showSearch && (
              <input
                type="text"
                placeholder="חיפוש..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="search-line-inline"
                autoFocus
              />
            )}
          </div>

          <h1 className="user-title">משתמשים</h1>

          <button className="add-lead-button" onClick={addUser}>
            +
            <span className='add'>
              הוספת משתמש
            </span>
          </button>
        </div>
      </div>

      {view === 'board' ? ( 
        <GenericBoard data={filteredUsers} openItemPopup={openUserPopup}  config={config} lookups={{}} />
      ) : (
        <GenericTab data={filteredUsers} openItemPopup={openUserPopup} config={configTab} lookups={{}} />
      )}
      {modalOpen && (
        <Modal key={selectedUser.id} open={modalOpen} onClose={() => setModalOpen(false)} >
          <Box
            sx={{
              backgroundColor: '#fff',
              display: "flex",
              flexDirection: 'row',
              padding: '20px',
              borderRadius: '10px',
              // border: '1px solid #ccc',
              // boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
              width: '80%',
              height: "60%",
              top: "50%",
              left: "50%",
              position: 'absolute',
              direction: 'rtl',
              transform: 'translate(-50%, -50%)'
            }}
          >
            {selectedUser && (
              <>
                <UserInfoView
                  selectedUser={selectedUser}
                  refresh={fetchData}
                  onClose={() => setModalOpen(false)}
                />
                <ChatTable itemId={selectedUser.id}></ChatTable>
              </>
            )}
          </Box>
        </Modal>
      )}
    </div>
  );
};

export default UserTable;
